
import React from "react";
import KayttokohteetCard from "./KayttokohteetCard";
import { getOptimizedImageUrl } from "@/utils/imageOptimizer";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Käytetään käyttäjän toimittamia kuvia jokaiselle kortille
const loanTypeImages = [
  "/lovable-uploads/399689b6-3783-4622-a34a-39c750296418.png",
  "/lovable-uploads/21e5cbb6-8c52-4e23-8c29-62120505d973.png",
  "/lovable-uploads/b37e1a3c-b3fb-4ddd-a3b1-a30d0ede3d20.png",
  "/lovable-uploads/babf7dda-5784-4c17-aed8-603cc8bf535b.png"
];

const LoanTypesSection: React.FC = () => {
  return (
    <section className="py-10 md:py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-2">Lainatuotteet</h2>
        <p className="text-gray-600 text-center mb-8 md:mb-10 max-w-2xl mx-auto">
          Lainasampo.fi tarjoaa erilaisia lainatuotteita erilaisiin elämäntilanteisiin
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          <KayttokohteetCard 
            title="Asuntolaina" 
            description="Unelmien kodin hankintaan"
            imagePath={getOptimizedImageUrl(loanTypeImages[0], 800)}
            link="/lainat/asuntolaina"
          />
          <KayttokohteetCard 
            title="Kulutusluotto" 
            description="Arjen hankintoihin joustavasti"
            imagePath={getOptimizedImageUrl(loanTypeImages[1], 800)}
            link="/lainat/kulutusluotto"
          />
          <KayttokohteetCard 
            title="Yhdistelylaina" 
            description="Selkeytä lainasi edullisesti"
            imagePath={getOptimizedImageUrl(loanTypeImages[2], 800)}
            link="/lainat/yhdistelylaina"
            bgColor="bg-green-100"
          />
          <KayttokohteetCard 
            title="Remonttilaina" 
            description="Kodin kunnostukseen ja sisustukseen"
            imagePath={getOptimizedImageUrl(loanTypeImages[3], 800)}
            link="/lainat/remonttilaina"
            bgColor="bg-blue-100"
          />
        </div>

        <div className="mt-8 text-center">
          <Link 
            to="/lainatuotteet" 
            className="inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold group"
          >
            Katso kaikki lainatuotteet
            <ArrowRight className="ml-1 h-4 w-4 group-hover:ml-2 transition-all" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LoanTypesSection;
